import { useState } from 'react'
import { Button } from 'semantic-ui-react'
import Link from 'next/link'

import AddVehicle from 'lib/components/Vehicle/Add'
import useUpdateUserData from 'lib/hooks/useUpdateUserData'
import { UseUserData } from 'lib/hooks/useUser'

export const VehicleFlow = ({ user }: { user: UseUserData }) => {
  const [showAdd, setShowAdd] = useState(false)
  const updateUserData = useUpdateUserData()

  const vehicle = user.data.vehicle

  if (vehicle) {
    return (
      <>
        <p>
          Tracking recalls for{' '}
          <strong>
            {vehicle.year} {vehicle.make} {vehicle.model}
          </strong>
          . You will receive a notification if a new recall comes in that
          affects your vehicle.
        </p>
        <p>
          You can{' '}
          <Link href="/search">
            <a>search</a>
          </Link>{' '}
          for active recalls on your vehicle to see past recalls.
        </p>
        <Button
          onClick={() => {
            updateUserData({ vehicle: null })
            setShowAdd(false)
          }}
          negative
          basic
        >
          Remove Vehicle
        </Button>
      </>
    )
  }

  if (!showAdd) {
    return (
      <Button
        primary
        onClick={() => {
          setShowAdd(true)
        }}
      >
        Add Vehicle
      </Button>
    )
  }

  return (
    <AddVehicle
      onSave={async vehicle => {
        updateUserData({ vehicle })
      }}
      onCancel={() => setShowAdd(false)}
    />
  )
}

export default VehicleFlow
